import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBudgetaryPeriods(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('budget/budget-period', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBudgetaryPeriod(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`budget/budget-period/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
